import ErrorImg from '@assets/403.png';
import VictronBlueLogo from '@assets/victron-logo-blue.svg';
import { Button, Typography } from '@mui/material';
import { toLogin } from '@utils/route';
import { FormattedMessage } from 'react-intl';

const Unauthenticated = () => (
    <div className="center-container text-center font-inter flex-col justify-between bg-victron-gradient sm:justify-center">
        <img src={ErrorImg} width={180} height={218} />
        <Typography
            className="text-3xl sm:text-4xl"
            fontFamily="museo-sans"
            fontWeight={600}
            lineHeight="150%"
            letterSpacing={0}
        >
            <FormattedMessage id="error.wrongSpot" defaultMessage="Whoops! Looks like you're in the wrong spot!" />
        </Typography>
        <Typography
            className="text-xl sm:text-2xl"
            fontFamily="museo-sans"
            fontWeight={400}
            lineHeight="150%"
            letterSpacing={0}
            marginTop={1}
        >
            <FormattedMessage
                id="unauthenticated.description"
                defaultMessage="This page is only available to Victron Professional Users.{br} If that's you, please log in to continue."
                values={{ br: <br /> }}
            />
        </Typography>
        <Button
            color="primary"
            className="rounded-full w-full sm:w-fit min-w-[200px] sm:mt-10"
            size="large"
            component="a"
            href={toLogin()}
        >
            <Typography fontFamily="Inter" fontWeight={500} fontSize={16} lineHeight="150%">
                <FormattedMessage id="common.login" defaultMessage="Login" />
            </Typography>
        </Button>
        <div className="sm:absolute sm:bottom-10 sm:mx-5">
            <img src={VictronBlueLogo} width={241} height={46} />
        </div>
    </div>
);

export { Unauthenticated };
